

  import Vue from 'vue'
  import Component from "vue-class-component";
  import {Prop, PropSync, VModel} from "vue-property-decorator";

  @Component({})
  export default class SimpleConfirmationDialog extends Vue {

    @VModel()
    protected dialogShowing!: boolean;
    @Prop({ default: '' })
    protected title!: string;
    @Prop()
    protected disabled!: boolean;
    @Prop({default : false})
    protected persistent!: boolean;
    @Prop({ default: false })
    protected wide!: boolean|string;
    @Prop({ default: false })
    protected cantBeUndone!: boolean;
    @Prop({ default: '' })
    protected help!:string;

    protected get maxWidth(): number {
      if (this.wide === 'extra') {
        return 800;
      }
      else if (this.wide !== false) {
        return 600;
      }
      return 300;
    }

    protected get getTitle(): string {
      return this.title == '' ? 'common.confirmOperation' : this.title;
    }

    protected onSubmit() {
      this.$emit('submit');
    }
    protected onCancel() {
      this.$emit('cancel');
      this.dialogShowing = false;
    }
  }

